import { createSlice } from "@reduxjs/toolkit";
import {
  DeletePermanentlyFilesFolderAction,
} from "store/middlewares/general";
import {
  GetTrashFilesFoldersAction,
} from "store/middlewares/trash";



export const trashSlice = createSlice({
  name: "trash",
  initialState: {
    trash: null,
    trashLoading: false,
  },
  reducers: {
    perminentDeleteFilesAndFolders: (state, action) => {
      const deletedFolders = action.payload?.folders || [];
      const deletedFiles = action.payload?.files || [];

      const deletedFolderIds = deletedFolders.map((f) => f.id);
      const deletedFileIds = deletedFiles.map((f) => f.id);

      state.trash = {
        ...state.trash,
        data: {
          ...state.trash?.data,

          folders: state.trash?.data?.folders?.filter(
            (folder) => !deletedFolderIds.includes(folder.id),
          ),

          files: state.trash?.data?.files?.filter(
            (file) => !deletedFileIds.includes(file.id),
          ),
        },
      };
    },
    trashEmpty: (state) => {
      state.trash = null;
    },
    addTrashItems: (state, action) => {
      const newData = action.payload;

      if (!state?.trash?.data) {
        state.trash = {
          data: {
            folders: [],
            files: [],
          },
        };
      }

   
      state.trash = {
        ...state.trash,
        data: {
          folders: [
            ...(newData?.folders || []),
            ...(state?.trash?.data?.folders || []),
          ],
          files: [
            ...(newData?.files || []),
            ...(state?.trash?.data?.files || []),
          ],
        },
      };
    },
    restoreItems: (state, action) => {
      const restoredFolders = action.payload?.folders || [];
      const restoredFiles = action.payload?.files || [];

      const restoredFolderIds = restoredFolders.map((f) => f.id);
      const restoredFileIds = restoredFiles.map((f) => f.id);

      state.trash = {
        ...state.trash,
        data: {
          ...state.trash?.data,

          folders: state.trash?.data?.folders?.filter(
            (folder) => !restoredFolderIds.includes(folder.id),
          ),

          files: state.trash?.data?.files?.filter(
            (file) => !restoredFileIds.includes(file.id),
          ),
        },
      };
    }
  },
  extraReducers(builder) {
    builder
      .addCase(GetTrashFilesFoldersAction.pending, (state) => {
        state.trashLoading = state.trash?.total > 0 ? false : true;
      })
      .addCase(GetTrashFilesFoldersAction.fulfilled, (state, action) => {
        state.trashLoading = false;
        const newData = action.payload?.response;
        if (newData.page === 1) {
          state.trash = newData;
        } else {
          state.trash = {
            ...newData,
            data: {
              folders: [
                ...state.trash.data.folders,
                ...(newData?.data?.folders || []),
              ],
              files: [
                ...state.trash.data.files,
                ...(newData?.data?.files || []),
              ],
            },
          };
        }
      })
      .addCase(GetTrashFilesFoldersAction.rejected, (state) => {
        state.trashLoading = false;
      })
      // .addCase(UploadFilesAction.fulfilled, (state, action) => {
      //   const newFiles = action.payload.response?.uploaded || [];
      //   // const mergedFiles = [...newFiles, ...state.files.data];
      //   // mergedFiles.sort((a, b) =>
      //   //   a.file_name.localeCompare(b.file_name, undefined, {
      //   //     numeric: true,
      //   //     sensitivity: "base",
      //   //   }),
      //   // );
      //   if (action.payload.response?.uploaded[0]?.folder_id === null) {
      //     state.files.data = [...newFiles, ...state.files.data];
      //   }
      // })
      // delete File Permanently To Trash

      .addCase(
        DeletePermanentlyFilesFolderAction.fulfilled,
        (state, action) => {
          const deletedFolders = action.payload?.response?.folders || [];
          const deletedFiles = action.payload?.response?.files || [];

          const deletedFolderIds = deletedFolders.map((f) => f.id);
          const deletedFileIds = deletedFiles.map((f) => f.id);

          state.trash = {
            ...state.trash,
            data: {
              ...state.trash?.data,

              folders: state.trash?.data?.folders?.filter(
                (folder) => !deletedFolderIds.includes(folder.id),
              ),

              files: state.trash?.data?.files?.filter(
                (file) => !deletedFileIds.includes(file.id),
              ),
            },
          };
        },
      )

    // .addCase(RestoreFilesFolderAction.fulfilled, (state, action) => {
    //   const restoredFolders = action.payload?.response?.folders || [];
    //   const restoredFiles = action.payload?.response?.files || [];

    //   const restoredFolderIds = restoredFolders.map((f) => f.id);
    //   const restoredFileIds = restoredFiles.map((f) => f.id);

    //   state.trash = {
    //     ...state.trash,
    //     data: {
    //       ...state.trash?.data,

    //       folders: state.trash?.data?.folders?.filter(
    //         (folder) => !restoredFolderIds.includes(folder.id),
    //       ),

    //       files: state.trash?.data?.files?.filter(
    //         (file) => !restoredFileIds.includes(file.id),
    //       ),
    //     },
    //   };
    // })

    // .addCase(EmptyTrashAction.fulfilled, (state) => {
    //   state.trash = null;
    // });
  },
});

export const { perminentDeleteFilesAndFolders, trashEmpty, addTrashItems, restoreItems } = trashSlice.actions;


export default trashSlice.reducer;
